import axios from "axios";
import QS from 'qs';
import {Notify} from "vant";
import { Dialog } from 'vant';

// 添加请求拦截器
// axios.interceptors.request.use(config => {
//
//   return config
// })
// 添加响应拦截器?
axios.interceptors.response.use(
  response =>{
    //请求成功
    //status  服务器返回的状态码
    // if(response.status !== 200){
    //   return Promise.reject(response.data)
    // }else {
      //与后端约定的状态码
      if(response.data.status === 200){
        return Promise.resolve(response.data)
      }else{
        let code = response.data.status;
        switch (code) {
          case 600:
            //token失效
            Dialog.alert({
              title: '提示',
              message: '链接已失效，请重新通过辅导员获取链接',
              showConfirmButton:false
            })
            break;
          default:
            //token失效
            Notify({type: 'warning', message: response.data.msg});
            break;
        }
        // 你就把这一行放在这，你管上面呢，弹框不是想怎么写怎么写，这句话写一遍不就行了
        return new Promise(()=>{})
      }
    // }
  },
  err => {
    //请求错误
    if(err.response){
      Notify({type: 'warning', message: err.response.data.message});
      return new Promise(()=>{})
    }
  }
)

export function post(headers,url, params){
  console.log(QS.stringify(params))
  return axios({
    url,
    method: 'post',
    data:QS.stringify(params),
    headers
  })
}
export function request(url, params){
  console.log(url)
  return axios({
    url,
    method: 'post',
    data:QS.stringify(params)
  })
}


export function get(headers,url, params) {
  return axios({
      url,
      method:"get",
      params:params,
      headers,
    })
}



// WEBPACK FOOTER //
// ./src/request/http.js